import styled from 'styled-components';
import ReactMarkdown from 'react-markdown';

// ============================================
// AnswerMarkdown — AI 답 글(표 없는 답 본문 · 표 앞뒤 intro/outro)
// ============================================
// 굵게·목록·빈 줄 문단은 마크다운으로 그린다.
// keepBreaks: 한 줄 바꿈(\n 하나)도 화면에서 줄을 바꾼다. 마크다운은 원래 한 줄 바꿈을 공백으로 합치는데,
//   신 경로 서버는 「항목: 값」 줄을 \n 하나로 잇기 때문에 그대로 두면 여러 줄이 한 문단으로 뭉개진다.
//   글을 고치지 않고(타이핑 도중 글자가 흔들리지 않게) 문단 안의 줄바꿈 문자만 CSS 로 살린다.
//   레거시 /ai(useAiChat)는 종전 모양을 지키려고 끈 채로 쓴다.

export default function AnswerMarkdown({ text, color, keepBreaks = false, lineHeight = 22 }) {
  return (
    <MarkdownBody color={color} $keepBreaks={keepBreaks} $lineHeight={lineHeight}>
      <ReactMarkdown>{text}</ReactMarkdown>
    </MarkdownBody>
  );
}

// 줄바꿈 보존은 p 에만 건다 — ul/ol 은 li 사이에 줄바꿈 문자 노드가 있어 컨테이너 전체에 걸면 빈 줄이 생긴다.
// 한 줄 바꿈이 줄을 바꾸게 되면 빈 줄 문단과 구분이 안 되므로 keepBreaks 일 때는 문단·목록 간격을 8px 로 벌린다 //
const MarkdownBody = styled.div`
  font-family: NotoSansKR-Regular;
  font-size: 14px;
  line-height: ${props => props.$lineHeight}px;
  color: ${props => props.color};
  margin: 0;

  p { margin: ${props => props.$keepBreaks ? 8 : 4}px 0; ${props => props.$keepBreaks && 'white-space: pre-line;'} }
  p:first-child { margin-top: 0; }
  p:last-child { margin-bottom: 0; }
  strong { font-family: NotoSansKR-Bold; }
  ul, ol { margin: ${props => props.$keepBreaks ? 8 : 4}px 0; padding-left: 20px; }
  ${props => props.$keepBreaks && 'ul:last-child, ol:last-child { margin-bottom: 0; }'}
  li { margin: 2px 0; }
`;
